import { render, staticRenderFns } from "./ShiftAdd.vue?vue&type=template&id=39b77ae4&"
import script from "./ShiftAdd.vue?vue&type=script&setup=true&lang=js&"
export * from "./ShiftAdd.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports